
<div class="page-header-main-bckg">

  <div class="pad-all text-center">
    <h3>{{'WelcomeBackToDashboard' | translate}}</h3>
  </div>
</div>

